import {useImageResource} from "hooks/queries/image-resource-query"

interface RepresentationImageProps {
    images: string[] | undefined
}

export const RepresentationImage = ({images}: RepresentationImageProps) => {
    if(!images || images.length === 0 ) return (
        <img src={"img/i-img.png"} alt="" width={140} style={{maxHeight: 160}}/>
    )
    return <RemoteImage id={images[0]}/>
}

export const RemoteImage = ({id}: {id: string})  => {
    const {data: imageResource} = useImageResource(id)
    // console.log("imageResource", imageResource)
    if(!imageResource) return (
        <img src={"img/i-img.png"} alt="" width={140} style={{maxHeight: 160}}/>
    )
    const url = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_FILE_RESOURCE_URL}${imageResource.fileName}`
    // console.log("URL : ", url)
    return (
        <img src={url} alt="" width={140} style={{maxHeight: 160}}/>
    )
}